var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8308 7.48034L10.5197 4.16916M1 17L3.80156 16.6887C4.14385 16.6507 4.31499 16.6317 4.47496 16.5799C4.61688 16.5339 4.75194 16.469 4.87647 16.3869C5.01684 16.2943 5.1386 16.1726 5.38212 15.9291L16.3142 4.99696C17.2286 4.0826 17.2286 2.60013 16.3142 1.68577C15.3999 0.771411 13.9174 0.77141 13.0031 1.68577L2.07094 12.6179C1.82742 12.8614 1.70566 12.9832 1.6131 13.1235C1.53097 13.2481 1.46606 13.3831 1.42012 13.525C1.36833 13.685 1.34932 13.8561 1.31128 14.1984L1 17Z",
    stroke: "#FF7E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon1);
export default __webpack_public_path__ + "static/media/create-icon-1.82678b4e2389e30b93f2857556776174.svg";
export { ForwardRef as ReactComponent };